import { render, staticRenderFns } from "./tipiParametriValori.vue?vue&type=template&id=d2bb5b6e&"
import script from "./tipiParametriValori.vue.ts?vue&type=script&lang=ts&"
export * from "./tipiParametriValori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports